/**
 * ZK Device Management
 *
 * Main component for ZK time clock integration with sub-tabs.
 */

import React, { useState } from 'react';
import { Tabs, Card } from 'antd';
import {
  DesktopOutlined,
  TeamOutlined,
  SyncOutlined,
  DatabaseOutlined
} from '@ant-design/icons';
import ZKDeviceList from './ZKDeviceList';
import ZKEmployeeMapping from './ZKEmployeeMapping';
import ZKSyncPanel from './ZKSyncPanel';
import ZKRawAttendance from './ZKRawAttendance';

const ZKDeviceManagement: React.FC = () => {
  const [activeSubTab, setActiveSubTab] = useState('devices');

  const tabItems = [
    {
      key: 'devices',
      label: (
        <span>
          <DesktopOutlined />
          Devices
        </span>
      ),
      children: <ZKDeviceList />
    },
    {
      key: 'mapping',
      label: (
        <span>
          <TeamOutlined />
          Employee Mapping
        </span>
      ),
      children: <ZKEmployeeMapping />
    },
    {
      key: 'sync',
      label: (
        <span>
          <SyncOutlined />
          Sync & History
        </span>
      ),
      children: <ZKSyncPanel />
    },
    {
      key: 'raw',
      label: (
        <span>
          <DatabaseOutlined />
          Raw Data
        </span>
      ),
      children: <ZKRawAttendance />
    }
  ];

  return (
    <Card>
      <Tabs
        activeKey={activeSubTab}
        onChange={setActiveSubTab}
        items={tabItems}
      />
    </Card>
  );
};

export default ZKDeviceManagement;
